import React, { useState } from 'react';
import { useTranslations } from 'js/hooks/i18n';
import { Button } from 'js/components/common/Button';
import { useFormatter } from 'js/hooks/useFormatter';

import * as hooks from './hooks';

import style from './PendingLimitsItem.scss';

export const PendingLimitsItem = ({ limit, setConfirmError, isFormLoading, fetchLimits }) => {
    const formatter = useFormatter();
    const [isLoading, setIsLoading] = useState(false);
    const t = useTranslations('playtech.mobile.system.responsibleGaming.limits.');
    const { startDate, limit: { amount, currencyCode } = {}, acceptanceNeeded } = limit;
    const allowActions = acceptanceNeeded === 0 || acceptanceNeeded === 1;
    const params = { fetchLimits, setIsLoading, setConfirmError };
    const accept = hooks.useConfirmPlayerLimits({ action: 'accept', ...params });
    const decline = hooks.useConfirmPlayerLimits({ action: 'decline', ...params });

    return (
        <div className={style.pending}>
            <div className={style.pendingInfo}>
                <span className={style.text}>
                    {`${t('to')} ${formatter.formatCurrency(amount, { currencyCode })}`}
                </span>
                <span className={style.date}>
                    {startDate && formatter.getDateTimeShort(formatter.parseImsDate(startDate))}
                </span>
            </div>
            {allowActions && <div className={style.pendingActions}>
                <Button
                    type="button"
                    color='negative'
                    onClick={decline}
                    className={style.btn}
                    disabled={isLoading || isFormLoading}
                >
                    {t('decline')}
                </Button>
                <Button
                    type="button"
                    onClick={accept}
                    className={style.btn}
                    disabled={isLoading || acceptanceNeeded === 0 || isFormLoading}
                >
                    {t('accept')}
                </Button>
            </div>}
        </div>
    );
};
